const SCORE_OUT_OF_TEN = "score_out_of_ten";
const NORMALIZED_ZERO_TO_ONE = "normalized_zero_to_one";

export function toRecommendationScoreOutOfTen(value, unit) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string" && value.trim() === "") return null;
  if (unit !== SCORE_OUT_OF_TEN && unit !== NORMALIZED_ZERO_TO_ONE) return null;

  const numeric = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(numeric)) return null;

  if (unit === SCORE_OUT_OF_TEN) {
    return numeric >= 0 && numeric <= 10 ? numeric : null;
  }

  return numeric >= 0 && numeric <= 1 ? numeric * 10 : null;
}

export function formatRecommendationScoreOutOfTen(value, unit) {
  const score = toRecommendationScoreOutOfTen(value, unit);
  return score === null ? "—" : `${score.toFixed(1)} / 10`;
}
